// {
//   "name": "iconic-also-bought.js",
//   "author": "Arham Web Works",
//   "description": "Copying in any form is strictly prohibited. Any instance of copying will be subject to legal action and accountability under the law."
// }

(function () {
  var CART_ADD_URL = (window.routes && window.routes.cart_add_url) || '/cart/add.js';
  var CART_URL = (window.routes && window.routes.cart_url) || '/cart';

  var __iconicAlsoBoughtBusy = false;
  var __iconicAlsoBoughtPlannedScrollAt = 0;
  var __iconicAlsoBoughtIgnoreEmptyUntil = 0;

  function getCurrency() {
    return (
      (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) ||
      document.documentElement.getAttribute('data-currency') ||
      'USD'
    );
  }

  function formatMoney(cents, currencySymbol) {
    if (currencySymbol) {
      return currencySymbol + (cents / 100).toFixed(2);
    }
    var formatted = new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: getCurrency(),
      currencyDisplay: 'symbol',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(cents / 100);
    return formatted.replace(/^US\s*/i, '');
  }

  function getVariantFromCard(card) {
    var select = card.querySelector('[data-iconic-also-bought-variant-select]');
    if (select) {
      var opt = select.selectedIndex >= 0 ? select.options[select.selectedIndex] : null;
      if (!opt || !opt.value) {
        for (var i = 0; i < select.options.length; i++) {
          if (select.options[i].value && !select.options[i].disabled) {
            opt = select.options[i];
            break;
          }
        }
      }
      if (opt && opt.value) {
        var available = opt.dataset.available !== 'false' && opt.dataset.available !== false;
        return {
          id: String(opt.value),
          price: parseInt(opt.dataset.price, 10),
          compare: parseInt(opt.dataset.compare, 10) || 0,
          available: available,
        };
      }
    }
    var hidden = card.querySelector('[data-iconic-also-bought-variant-id]');
    if (hidden && hidden.value) {
      var av = hidden.dataset.available !== 'false' && hidden.dataset.available !== false;
      return {
        id: String(hidden.value),
        price: parseInt(hidden.dataset.price, 10),
        compare: parseInt(hidden.dataset.compare, 10) || 0,
        available: av,
      };
    }
    return null;
  }

  function isProductPage() {
    if (document.body && document.body.classList.contains('template-product')) return true;
    return /\/products\//.test(window.location.pathname);
  }

  function isCartPage() {
    if (document.body && document.body.classList.contains('template-cart')) return true;
    return /\/cart(?:\/|$)/.test(window.location.pathname);
  }

  function jumpToCartTopInstant() {
    var cartItemsEl = document.getElementById('main-cart-items');
    var prevHtmlScrollBehavior = '';
    var prevBodyScrollBehavior = '';
    try {
      prevHtmlScrollBehavior = document.documentElement.style.scrollBehavior || '';
      prevBodyScrollBehavior = document.body.style.scrollBehavior || '';
      document.documentElement.style.setProperty('scroll-behavior', 'auto', 'important');
      document.body.style.setProperty('scroll-behavior', 'auto', 'important');
    } catch (e) {
    }

    if (cartItemsEl) {
      var y = cartItemsEl.getBoundingClientRect().top + window.pageYOffset - 20;
      window.scrollTo(0, Math.max(0, y));
    } else {
      window.scrollTo(0, 0);
    }

    try {
      setTimeout(function () {
        if (prevHtmlScrollBehavior) {
          document.documentElement.style.setProperty('scroll-behavior', prevHtmlScrollBehavior);
        } else {
          document.documentElement.style.removeProperty('scroll-behavior');
        }
        if (prevBodyScrollBehavior) {
          document.body.style.setProperty('scroll-behavior', prevBodyScrollBehavior);
        } else {
          document.body.style.removeProperty('scroll-behavior');
        }
      }, 0);
    } catch (e) {
      /* ignore */
    }
  }

  function updateCardPrice(card, currencySymbol) {
    var priceRow = card.querySelector('[data-iconic-also-bought-row-price]');
    if (!priceRow) return;
    var v = getVariantFromCard(card);
    if (!v) return;
    var sym = currencySymbol || '';
    var html = '';
    if (v.compare && v.compare > v.price) {
      html +=
        '<span class="iconic-also-bought-current-price iconic-also-bought-current-price--on-sale iconic-fw-bold">' +
        formatMoney(v.price, sym) +
        '</span><s class="iconic-also-bought-compare-price iconic-fw-bold">' +
        formatMoney(v.compare, sym) +
        '</s>';
    } else {
      html += '<span class="iconic-also-bought-current-price iconic-fw-bold">' + formatMoney(v.price, sym) + '</span>';
    }
    priceRow.innerHTML = html;

    var badge = card.querySelector('.iconic-also-bought-card__badge');
    var badgeType = card.dataset.saleBadgeType || 'text';
    var badgeText = card.dataset.saleBadgeText || 'SALE';
    
    if (badge) {
      if (badgeType === 'percentage') {
        if (v.compare && v.compare > v.price) {
          var pct = Math.round(((v.compare - v.price) * 100) / v.compare);
          badge.textContent = pct + '% OFF';
        } else {
          badge.textContent = badgeText;
        }
      } else if (badgeType === 'amount') {
        if (v.compare && v.compare > v.price) {
          badge.textContent = formatMoney(v.compare - v.price, sym) + ' OFF';
        } else {
          badge.textContent = badgeText;
        }
      } else {
        badge.textContent = badgeText;
      }
    }

    var btn = card.querySelector('[data-iconic-also-bought-add]');
    var addToCartLabel = (btn && btn.getAttribute('data-iconic-also-bought-add-label')) || 'ADD TO CART';
    var soldOutLabel = (btn && btn.getAttribute('data-iconic-also-bought-sold-out-label')) || 'SOLD OUT';
    if (v.available) {
      card.classList.remove('iconic-also-bought-card--sold-out');
      if (btn) {
        btn.disabled = false;
        btn.removeAttribute('aria-disabled');
        btn.textContent = addToCartLabel;
      }
    } else {
      card.classList.add('iconic-also-bought-card--sold-out');
      if (btn) {
        btn.disabled = true;
        btn.setAttribute('aria-disabled', 'true');
        btn.textContent = soldOutLabel;
      }
    }

    var opt = card.querySelector('[data-iconic-also-bought-variant-select]');
    if (opt && opt.selectedOptions && opt.selectedOptions[0]) {
      var imgUrl = opt.selectedOptions[0].getAttribute('data-image');
      if (imgUrl) {
        var img = card.querySelector('[data-iconic-also-bought-image]');
        if (img) img.setAttribute('src', imgUrl);
      }
    }
  }

  function getCartPageSectionsToRender() {
    var list = [];
    var mainCartItems = document.getElementById('main-cart-items');
    if (mainCartItems && mainCartItems.dataset.id) {
      list.push({
        domId: 'main-cart-items',
        section: mainCartItems.dataset.id,
        selector: '.js-contents',
      });
    }
    var mainCartFooter = document.getElementById('main-cart-footer');
    if (mainCartFooter && mainCartFooter.dataset.id) {
      list.push({
        domId: 'main-cart-footer',
        section: mainCartFooter.dataset.id,
        selector: '.js-contents',
      });
    }
    list.push({
      domId: 'cart-icon-bubble',
      section: 'cart-icon-bubble',
      selector: '.shopify-section',
    });
    return list;
  }

  function getSectionInnerHTML(html, selector) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var node = doc.querySelector(selector);
    return node ? node.innerHTML : '';
  }

  function replaceCartPageSections(data) {
    if (!data || !data.sections) return;
    getCartPageSectionsToRender().forEach(function (section) {
      var sectionHtml = data.sections[section.section];
      if (!sectionHtml) return;
      var target = document.getElementById(section.domId);
      if (!target) return;
      var elementToReplace = target.querySelector(section.selector) || target;
      elementToReplace.innerHTML = getSectionInnerHTML(sectionHtml, section.selector);
    });
    var cartItems = document.querySelector('cart-items');
    if (cartItems && data.item_count > 0) cartItems.classList.remove('is-empty');
    var cartFooter = document.getElementById('main-cart-footer');
    if (cartFooter && typeof data.item_count === 'number') {
      cartFooter.classList.toggle('is-empty', data.item_count === 0);
    }
  }

  function addSingleToCart(variantId, buttonEl, done, options) {
    options = options || {};
    var silent = options.silent === true;
    var alsoBoughtWrapper = silent ? getCartPageAlsoBoughtSectionWrapper() : null;
    var cartDrawer = document.querySelector('cart-drawer');
    var cartNotification = document.querySelector('cart-notification');

    if (silent) {
      __iconicAlsoBoughtBusy = true;
      document.querySelectorAll('iconic-also-bought').forEach(function (rootEl) {
        if (!isCartPage() || isInCartDrawer(rootEl)) return;
        rootEl.setAttribute('data-iconic-also-bought-busy', 'true');
      });
    }

    var sectionsToRequest = [];

    if (silent) {
      getCartPageSectionsToRender().forEach(function (s) {
        if (s.section && sectionsToRequest.indexOf(s.section) === -1) sectionsToRequest.push(s.section);
      });
      if (alsoBoughtWrapper && alsoBoughtWrapper.id) {
        var alsoBoughtSectionId = alsoBoughtWrapper.id.replace('shopify-section-', '');
        if (alsoBoughtSectionId && sectionsToRequest.indexOf(alsoBoughtSectionId) === -1) {
          sectionsToRequest.push(alsoBoughtSectionId);
        }
      }
    } else if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
      try {
        cartDrawer.getSectionsToRender().forEach(function (s) {
          var secId = s.id || s.section;
          if (secId && sectionsToRequest.indexOf(secId) === -1) sectionsToRequest.push(secId);
        });
      } catch (e) { }
    } else if (cartNotification && typeof cartNotification.getSectionsToRender === 'function') {
      try {
        cartNotification.getSectionsToRender().forEach(function (s) {
          var secId = s.id || s.section;
          if (secId && sectionsToRequest.indexOf(secId) === -1) sectionsToRequest.push(secId);
        });
      } catch (e) { }
    }

    if (!silent) {
      document.querySelectorAll('.shopify-section').forEach(function (el) {
        var id = el.id.replace('shopify-section-', '');
        if ((id.indexOf('cart') !== -1 || id.indexOf('header') !== -1) && sectionsToRequest.indexOf(id) === -1) {
          sectionsToRequest.push(id);
        }
      });
    }

    if (!silent && cartDrawer && typeof cartDrawer.setActiveElement === 'function' && buttonEl) {
      cartDrawer.setActiveElement(buttonEl);
    }

    var reqBody = {
      id: String(variantId),
      quantity: 1,
      sections: sectionsToRequest,
      sections_url: window.location.pathname
    };

    fetch(CART_ADD_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(reqBody)
    })
      .then(function (res) {
        return res.json().then(function (data) {
          return { ok: res.ok, data: data };
        });
      })
      .then(function (result) {
        var data = result.data;
        if (!result.ok || (data.status && data.message)) {
          alert(data.message || 'Could not add item to cart.');
          done(false);
          return;
        }

        var handledByDawn = false;

        if (silent) {
          replaceCartPageSections(data);
          handledByDawn = true;
          if (alsoBoughtWrapper && data.sections) {
            var alsoBoughtSectionId = alsoBoughtWrapper.id.replace('shopify-section-', '');
            var alsoBoughtHtml = data.sections[alsoBoughtSectionId];
            if (alsoBoughtHtml) {
              var temp = document.createElement('div');
              temp.innerHTML = alsoBoughtHtml;
              var next = temp.querySelector('#' + alsoBoughtWrapper.id) || temp.querySelector('.shopify-section');
              if (next) {
                alsoBoughtWrapper.innerHTML = next.innerHTML;
                clearCartPageAlsoBoughtForceHidden();
                loadRecommendationBlocks(alsoBoughtWrapper);
                alsoBoughtWrapper
                  .querySelectorAll('[data-iconic-also-bought]:not([data-iconic-also-bought-bound])')
                  .forEach(bindProShell);
              }
            }
          }
        } else if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
          try {
            cartDrawer.renderContents(data);
            handledByDawn = true;
          } catch (e) {
            console.error('FBT Pro: cartDrawer.renderContents failed', e);
          }
        } else if (cartNotification && typeof cartNotification.renderContents === 'function') {
          try {
            cartNotification.renderContents(data);
            handledByDawn = true;
          } catch (e) {
            console.error('FBT Pro: cartNotification.renderContents failed', e);
          }
        }

        if (!handledByDawn && data.sections) {
          Object.keys(data.sections).forEach(function (sectionId) {
            if (!data.sections[sectionId]) return;
            var el = document.getElementById('shopify-section-' + sectionId) || document.getElementById(sectionId);
            if (el) {
              var tempDiv = document.createElement('div');
              tempDiv.innerHTML = data.sections[sectionId].trim();
              var firstChild = tempDiv.firstElementChild;
              if (firstChild && firstChild.id === el.id) {
                el.innerHTML = firstChild.innerHTML;
                el.className = firstChild.className;
              } else {
                el.innerHTML = tempDiv.innerHTML;
              }
            }
          });
        }

        try {
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: data }));
          document.dispatchEvent(new CustomEvent('ajaxProduct:added', { bubbles: true, detail: { product: data } }));
          if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
            window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'iconic-also-bought', cartData: data });
          }
        } catch (e) { }

        function finishAdd(cartState) {
          if (silent) {
            setTimeout(function () {
              __iconicAlsoBoughtBusy = false;
              document.querySelectorAll('iconic-also-bought').forEach(function (rootEl) {
                rootEl.removeAttribute('data-iconic-also-bought-busy');
              });
              if (cartState) {
                document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: cartState }));
                document.dispatchEvent(new CustomEvent('cart:build', { bubbles: true, detail: cartState }));
                handleCartChange(cartState);
              }
              if (isCartPage() && !isCartEmptyNow()) {
                __iconicAlsoBoughtBusy = true;
                document.querySelectorAll('iconic-also-bought').forEach(function (rootEl) {
                  if (!isCartPage() || isInCartDrawer(rootEl)) return;
                  rootEl.setAttribute('data-iconic-also-bought-busy', 'true');
                });
                var refreshDelay = 0;
                if (__iconicAlsoBoughtPlannedScrollAt && __iconicAlsoBoughtPlannedScrollAt > Date.now()) {
                  refreshDelay = Math.min(600, __iconicAlsoBoughtPlannedScrollAt - Date.now());
                }
                setTimeout(function () {
                  refreshCartPageAlsoBoughtSection();
                }, refreshDelay);
              }
              done(true);
            }, 0);
            return;
          }

          if (cartState) {
            document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: cartState }));
            document.dispatchEvent(new CustomEvent('cart:build', { bubbles: true, detail: cartState }));
            handleCartChange(cartState);
          }
          done(true);
        }

        fetch(CART_URL.replace(/\/?$/, '') + '.js', { headers: { Accept: 'application/json' } })
          .then(function (res) { return res.json(); })
          .then(function (cartState) {
            if (silent) {
              finishAdd(cartState);
              return;
            }

            var drawerOpened = false;

            if (cartDrawer && typeof cartDrawer.open === 'function') {
              cartDrawer.open();
              drawerOpened = true;
            } else if (cartNotification && typeof cartNotification.open === 'function') {
              cartNotification.open();
              drawerOpened = true;
            }

            var selectors = [
              '#CartDrawer', '.cart-drawer', '.drawer--right', '.sidebar-cart', '#mini-cart', '.mini-cart',
              '#cart-notification', '.cart-notification', '.cart-popup-wrapper', '[data-section-type="cart-drawer"]'
            ];

            var classListToAdd = ['is-active', 'active', 'open', 'is-open', 'show', 'is-visible'];
            var classListToRemove = ['hidden', 'critical-hidden', 'invisible', 'is-hidden'];

            selectors.forEach(function (selector) {
              var el = document.querySelector(selector);
              if (el) {
                classListToRemove.forEach(function (c) { el.classList.remove(c); });
                classListToAdd.forEach(function (c) { el.classList.add(c); });
                el.setAttribute('aria-hidden', 'false');
                drawerOpened = true;
              }
            });

            if (drawerOpened || handledByDawn) {
              var overlaySelectors = ['.drawer-overlay', '.cart-overlay', '.background-overlay', '#CartOverlay', '.js-drawer-overlay', '.modal-overlay'];
              overlaySelectors.forEach(function (selector) {
                var overlay = document.querySelector(selector);
                if (overlay) {
                  classListToRemove.forEach(function (c) { overlay.classList.remove(c); });
                  classListToAdd.forEach(function (c) { overlay.classList.add(c); });
                  overlay.setAttribute('aria-hidden', 'false');
                }
              });
              document.body.classList.add('cart-drawer-open', 'cart-open', 'overflow-hidden', 'is-drawer-open');
            }

            finishAdd(cartState);
          })
          .catch(function () {
            finishAdd(data);
          });

      })
      .catch(function (err) {
        console.error('FBT Pro Add to Cart Error:', err);
        if (silent) __iconicAlsoBoughtBusy = false;
        document.querySelectorAll('iconic-also-bought').forEach(function (rootEl) {
          rootEl.removeAttribute('data-iconic-also-bought-busy');
        });
        done(false);
      });
  }

  function isInCartDrawer(el) {
    if (!el || !el.closest) return false;
    return !!el.closest('cart-drawer, #CartDrawer, .cart-drawer, [data-iconic-also-bought-drawer-host]');
  }

  function applyLayoutContext(rootEl) {
    if (!rootEl) return;
    rootEl.classList.toggle('iconic-also-bought--in-drawer', isInCartDrawer(rootEl));
  }

  function resolveAlsoBoughtRoot(root) {
    if (!root) return null;
    if (root.matches && root.matches('iconic-also-bought')) return root;
    if (root.querySelector) {
      var nested = root.querySelector('iconic-also-bought');
      if (nested) return nested;
    }
    return root.closest ? root.closest('iconic-also-bought') : null;
  }

  function scheduleScrollbarRefresh(carousel, delays) {
    if (!carousel || !carousel._fbtUpdateScrollbar) return;
    var run = carousel._fbtUpdateScrollbar;
    run();
    requestAnimationFrame(run);
    (delays || [100, 350, 800]).forEach(function (ms) {
      setTimeout(run, ms);
    });
  }

  function refreshScrollbarsInRoot(root) {
    var scope = root || document;
    if (!scope.querySelectorAll) return;
    scope.querySelectorAll('[data-iconic-also-bought-carousel]').forEach(function (carousel) {
      if ((carousel.getAttribute('data-nav-type') || '') === 'scrollbar') {
        scheduleScrollbarRefresh(carousel);
      }
    });
  }

  function initCarousel(root) {
    var alsoBoughtRoot = resolveAlsoBoughtRoot(root) || root;
    applyLayoutContext(alsoBoughtRoot);
    var scope = alsoBoughtRoot || root;
    if (!scope || !scope.querySelectorAll) return;
    scope.querySelectorAll('[data-iconic-also-bought-carousel]').forEach(function (carousel) {
      if (carousel.dataset.iconicAlsoBoughtCarouselInit === 'true') return;
      carousel.dataset.iconicAlsoBoughtCarouselInit = 'true';

      if (carousel.dataset.iconicAlsoBoughtSlider !== 'true') {
        return;
      }

      var track = carousel.querySelector('[data-iconic-also-bought-carousel-track]');
      var scrollEl =
        carousel.querySelector('[data-iconic-also-bought-carousel-scroll]') ||
        carousel.querySelector('.iconic-also-bought-carousel__viewport') ||
        track;
      var prev = carousel.querySelector('[data-iconic-also-bought-carousel-prev]');
      var next = carousel.querySelector('[data-iconic-also-bought-carousel-next]');
      var dotsWrap = carousel.querySelector('[data-iconic-also-bought-dots]');
      if (!track || !scrollEl) return;

      var navType = carousel.getAttribute('data-nav-type') || 'arrow';

      function cellStep() {
        var cell = track.querySelector('.iconic-also-bought-carousel__cell');
        if (!cell) return scrollEl.clientWidth * 0.85;
        var gap = parseFloat(getComputedStyle(track).gap) || 16;
        return cell.getBoundingClientRect().width + gap;
      }

      function updateArrows() {
        if (!prev || !next) return;
        var maxScroll = scrollEl.scrollWidth - scrollEl.clientWidth;
        var eps = 1;
        if (maxScroll < eps) {
          prev.disabled = true;
          next.disabled = true;
          return;
        }
        prev.disabled = scrollEl.scrollLeft <= eps;
        next.disabled = scrollEl.scrollLeft >= maxScroll - eps;
      }

      function bindTrackLayoutUpdates() {
        if (typeof ResizeObserver !== 'undefined') {
          try {
            var ro = new ResizeObserver(function () {
              updateArrows();
              if (navType === 'dots') buildDots();
              if (carousel._fbtUpdateScrollbar) carousel._fbtUpdateScrollbar();
            });
            ro.observe(scrollEl);
            ro.observe(track);
          } catch (e) {
          }
        }
        track.querySelectorAll('img').forEach(function (img) {
          function onImg() {
            updateArrows();
            if (navType === 'dots') buildDots();
            if (carousel._fbtUpdateScrollbar) carousel._fbtUpdateScrollbar();
          }
          if (img.complete) {
            onImg();
          } else {
            img.addEventListener('load', onImg);
            img.addEventListener('error', onImg);
          }
        });
      }

      function buildDots() {
        if (!dotsWrap || navType !== 'dots') return;
        dotsWrap.innerHTML = '';
        var step = cellStep();
        if (step <= 0) return;
        var count = Math.max(1, Math.ceil((scrollEl.scrollWidth - scrollEl.clientWidth) / step) + 1);
        for (var i = 0; i < count; i++) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'iconic-also-bought-dot';
          b.setAttribute('aria-label', 'Slide ' + (i + 1));
          (function (idx) {
            b.addEventListener('click', function () {
              scrollEl.scrollTo({ left: idx * step, behavior: 'smooth' });
            });
          })(i);
          dotsWrap.appendChild(b);
        }
        updateDotsActive();
      }

      function updateDotsActive() {
        if (!dotsWrap || navType !== 'dots') return;
        var step = cellStep();
        var idx = step > 0 ? Math.round(scrollEl.scrollLeft / step) : 0;
        var dots = dotsWrap.querySelectorAll('.iconic-also-bought-dot');
        dots.forEach(function (d, i) {
          d.classList.toggle('is-active', i === idx);
        });
      }

      function initScrollbar() {
        if (navType !== 'scrollbar') return;
        if (carousel.dataset.iconicAlsoBoughtScrollbarInit === 'true') {
          if (carousel._fbtUpdateScrollbar) carousel._fbtUpdateScrollbar();
          return;
        }
        var scrollbar = carousel.querySelector('[data-iconic-also-bought-scrollbar]');
        var thumb = carousel.querySelector('[data-iconic-also-bought-scrollbar-thumb]');
        var scrollbarTrack = scrollbar ? scrollbar.querySelector('.iconic-also-bought-scrollbar__track') : null;
        if (!scrollbar || !thumb || !scrollbarTrack) return;
        carousel.dataset.iconicAlsoBoughtScrollbarInit = 'true';

        function updateScrollbar() {
          var maxScroll = scrollEl.scrollWidth - scrollEl.clientWidth;
          if (maxScroll < 1) {
            scrollbar.classList.add('iconic-d-none');
            return;
          }
          scrollbar.classList.remove('iconic-d-none');
          var trackWidth = scrollbarTrack.clientWidth;
          if (trackWidth <= 0) {
            requestAnimationFrame(updateScrollbar);
            return;
          }
          var visibleRatio = scrollEl.clientWidth / scrollEl.scrollWidth;
          var thumbWidth = Math.max(visibleRatio * trackWidth, 40);
          var maxThumbLeft = Math.max(trackWidth - thumbWidth, 0);
          var scrollRatio = maxScroll > 0 ? scrollEl.scrollLeft / maxScroll : 0;
          carousel.style.setProperty('--iconic-also-bought-scrollbar-thumb-width', thumbWidth + 'px');
          carousel.style.setProperty('--iconic-also-bought-scrollbar-thumb-left', scrollRatio * maxThumbLeft + 'px');
        }

        function scrollFromPointer(clientX) {
          var rect = scrollbarTrack.getBoundingClientRect();
          var maxScroll = scrollEl.scrollWidth - scrollEl.clientWidth;
          if (maxScroll < 1 || rect.width <= 0) return;
          var thumbWidth = thumb.offsetWidth;
          var maxThumbLeft = Math.max(rect.width - thumbWidth, 0);
          var targetLeft = clientX - rect.left - thumbWidth / 2;
          targetLeft = Math.max(0, Math.min(targetLeft, maxThumbLeft));
          var scrollRatio = maxThumbLeft > 0 ? targetLeft / maxThumbLeft : 0;
          scrollEl.scrollLeft = scrollRatio * maxScroll;
        }

        var dragging = false;

        thumb.addEventListener('mousedown', function (e) {
          dragging = true;
          thumb.classList.add('is-dragging');
          e.preventDefault();
        });

        thumb.addEventListener(
          'touchstart',
          function (e) {
            dragging = true;
            thumb.classList.add('is-dragging');
          },
          { passive: true }
        );

        document.addEventListener('mousemove', function (e) {
          if (!dragging) return;
          scrollFromPointer(e.clientX);
        });

        document.addEventListener(
          'touchmove',
          function (e) {
            if (!dragging || !e.touches || !e.touches.length) return;
            scrollFromPointer(e.touches[0].clientX);
          },
          { passive: true }
        );

        function stopDragging() {
          if (!dragging) return;
          dragging = false;
          thumb.classList.remove('is-dragging');
        }

        document.addEventListener('mouseup', stopDragging);
        document.addEventListener('touchend', stopDragging);
        document.addEventListener('touchcancel', stopDragging);

        scrollbarTrack.addEventListener('click', function (e) {
          if (e.target === thumb) return;
          scrollFromPointer(e.clientX);
        });

        scrollEl.addEventListener('scroll', updateScrollbar);
        window.addEventListener('resize', updateScrollbar);
        if (typeof ResizeObserver !== 'undefined') {
          try {
            var scrollbarRo = new ResizeObserver(updateScrollbar);
            scrollbarRo.observe(scrollbarTrack);
            scrollbarRo.observe(scrollEl);
            scrollbarRo.observe(track);
          } catch (e) {
          }
        }
        carousel._fbtUpdateScrollbar = updateScrollbar;
        scheduleScrollbarRefresh(carousel);
      }

      if (prev) {
        prev.addEventListener('click', function () {
          if (prev.disabled) return;
          scrollEl.scrollBy({ left: -cellStep(), behavior: 'smooth' });
        });
      }
      if (next) {
        next.addEventListener('click', function () {
          if (next.disabled) return;
          scrollEl.scrollBy({ left: cellStep(), behavior: 'smooth' });
        });
      }

      scrollEl.addEventListener('scroll', function () {
        updateArrows();
        updateDotsActive();
      });

      window.addEventListener('resize', function () {
        updateArrows();
        if (navType === 'dots') buildDots();
      });

      bindTrackLayoutUpdates();
      updateArrows();
      if (navType === 'dots') buildDots();
      initScrollbar();
      if (navType === 'scrollbar') scheduleScrollbarRefresh(carousel);
      requestAnimationFrame(function () {
        updateArrows();
        if (navType === 'dots') buildDots();
        if (navType === 'scrollbar') scheduleScrollbarRefresh(carousel);
      });

      var autoplayEnabled = carousel.getAttribute('data-iconic-also-bought-autoplay-enabled') !== 'false';
      if (!autoplayEnabled) return;

      var autoplayMs = parseInt(carousel.getAttribute('data-iconic-also-bought-autoplay-ms'), 10);
      if (!autoplayMs || autoplayMs < 1500) autoplayMs = 5000;

      var autoplayPaused = false;

      function pauseAutoplay() {
        autoplayPaused = true;
      }

      function resumeAutoplay() {
        autoplayPaused = false;
      }

      function autoplayTick() {
        if (autoplayPaused || document.hidden) return;
        var maxScroll = scrollEl.scrollWidth - scrollEl.clientWidth;
        if (maxScroll < 2) return;
        var step = cellStep();
        if (step <= 0) return;
        var eps = 2;
        var atEnd = scrollEl.scrollLeft >= maxScroll - eps;
        if (atEnd) {
          scrollEl.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          scrollEl.scrollBy({ left: step, behavior: 'smooth' });
        }
      }

      carousel._fbtProAutoplayTimer = setInterval(autoplayTick, autoplayMs);
      carousel.addEventListener('mouseenter', pauseAutoplay);
      carousel.addEventListener('mouseleave', resumeAutoplay);
      carousel.addEventListener('focusin', pauseAutoplay);
      carousel.addEventListener('focusout', resumeAutoplay);
      scrollEl.addEventListener('touchstart', pauseAutoplay, { passive: true });
      scrollEl.addEventListener('touchend', resumeAutoplay, { passive: true });
      scrollEl.addEventListener('touchcancel', resumeAutoplay, { passive: true });
    });
  }

  function mountCartDrawerAlsoBought() {
    var host = document.querySelector('[data-iconic-also-bought-drawer-host]');
    if (!host || host.dataset.iconicAlsoBoughtDrawerLoaded === 'true') return;
    var sectionKey = host.getAttribute('data-section-id');
    if (!sectionKey) return;

    var cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && cartDrawer.classList.contains('is-empty')) return;

    host.dataset.iconicAlsoBoughtDrawerLoaded = 'true';
    var cartUrl = (window.routes && window.routes.cart_url) || '/cart';
    var url = cartUrl.split('?')[0] + '?section_id=' + encodeURIComponent(sectionKey);

    fetch(url)
      .then(function (res) {
        return res.text();
      })
      .then(function (text) {
        var html = document.createElement('div');
        html.innerHTML = text;
        var sectionEl =
          html.querySelector('iconic-also-bought') ||
          html.querySelector('#shopify-section-' + sectionKey) ||
          html.querySelector('[id^="shopify-section-"]');
        if (!sectionEl) {
          host.dataset.iconicAlsoBoughtDrawerLoaded = 'false';
          return;
        }
        host.innerHTML = '';
        host.appendChild(sectionEl);
        applyLayoutContext(sectionEl);
        loadRecommendationBlocks(sectionEl);
        updateProRootVisibility(sectionEl);
        host.querySelectorAll('[data-iconic-also-bought]:not([data-iconic-also-bought-bound])').forEach(bindProShell);
        initCarousel(host);
      })
      .catch(function (err) {
        console.error('Iconic also bought cart drawer load failed', err);
        host.dataset.iconicAlsoBoughtDrawerLoaded = 'false';
      });
  }

  function bindProShell(shell) {
    if (!shell || shell.dataset.iconicAlsoBoughtBound === 'true') return;
    shell.dataset.iconicAlsoBoughtBound = 'true';
    var rootEl = shell.closest('iconic-also-bought');
    applyLayoutContext(rootEl);
    var currencySymbol = shell.dataset.currencySymbol || '';

    shell.querySelectorAll('[data-iconic-also-bought-variant-select]').forEach(function (sel) {
      sel.addEventListener('change', function () {
        var card = sel.closest('[data-iconic-also-bought-card]');
        if (card) updateCardPrice(card, currencySymbol);
      });
    });

    shell.querySelectorAll('[data-iconic-also-bought-card]').forEach(function (card) {
      updateCardPrice(card, currencySymbol);
    });

    shell.querySelectorAll('[data-iconic-also-bought-add]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;
        if (!(isProductPage() || isCartPage() || isInCartDrawer(btn))) return;
        var card = btn.closest('[data-iconic-also-bought-card]');
        if (!card) return;
        var v = getVariantFromCard(card);
        if (!v || !v.available) return;
        if (isCartPage() && !isInCartDrawer(btn)) {
          var delayMs = 60;
          __iconicAlsoBoughtPlannedScrollAt = Date.now() + delayMs;
          __iconicAlsoBoughtIgnoreEmptyUntil = Date.now() + 700;
          setTimeout(function () {
            jumpToCartTopInstant();
          }, delayMs);
        }
        btn.setAttribute('aria-disabled', 'true');
        btn.classList.add('loading');
        addSingleToCart(
          v.id,
          btn,
          function () {
            btn.removeAttribute('aria-disabled');
            btn.classList.remove('loading');
          },
          { silent: isCartPage() || isInCartDrawer(btn) }
        );
      });
    });

    initCarousel(shell);
  }

  function sectionHasVisibleContent(rootEl) {
    if (!rootEl) return false;
    if (rootEl.getAttribute('data-iconic-also-bought-busy') === 'true') return true;
    if (rootEl.querySelector('[data-iconic-also-bought]')) return true;
    var rec = rootEl.querySelector('product-recommendations.iconic-also-bought-recommendations');
    if (rec && rec.dataset && rec.dataset.iconicAlsoBoughtLoading === 'true') return true;
    if (rec && rec.querySelector('[data-iconic-also-bought], [data-iconic-also-bought-card]')) return true;
    if (isCartPage() && !isInCartDrawer(rootEl)) return false;
    return !!(
      rootEl.querySelector('.iconic-also-bought-empty') ||
      rootEl.querySelector('.iconic-also-bought-empty')
    );
  }

  function getCartPageAlsoBoughtSectionEl() {
    var onPage = null;
    document.querySelectorAll('iconic-also-bought').forEach(function (root) {
      if (!onPage && isCartPage() && !isInCartDrawer(root)) onPage = root;
    });
    return (
      onPage ||
      document.getElementById('shopify-section-iconic-also-bought') ||
      document.querySelector('[id^="shopify-section-"] iconic-also-bought')
    );
  }

  function getCartPageAlsoBoughtSectionWrapper() {
    var root = getCartPageAlsoBoughtSectionEl();
    return root && root.closest ? root.closest('.shopify-section') : null;
  }

  function getAllCartPageAlsoBoughtWrappers() {
    var wrappers = [];
    document.querySelectorAll('iconic-also-bought').forEach(function (root) {
      if (!isCartPage() || isInCartDrawer(root)) return;
      var wrapper = root.closest('.shopify-section');
      if (wrapper && wrappers.indexOf(wrapper) === -1) wrappers.push(wrapper);
    });
    return wrappers;
  }

  function clearCartPageAlsoBoughtForceHidden() {
    getAllCartPageAlsoBoughtWrappers().forEach(function (wrapper) {
      wrapper.removeAttribute('data-iconic-also-bought-force-hidden');
      var root = wrapper.querySelector('iconic-also-bought');
      if (root) root.removeAttribute('data-iconic-also-bought-force-hidden');
    });
  }

  function hideCartPageAlsoBought() {
    getAllCartPageAlsoBoughtWrappers().forEach(function (wrapper) {
      wrapper.style.display = 'none';
      wrapper.setAttribute('data-iconic-also-bought-force-hidden', 'true');
      var root = wrapper.querySelector('iconic-also-bought');
      if (root) {
        root.style.display = 'none';
        root.setAttribute('data-iconic-also-bought-force-hidden', 'true');
      }
    });
    document.querySelectorAll('iconic-also-bought').forEach(function (rootEl) {
      if (!isCartPage() || isInCartDrawer(rootEl)) return;
      rootEl.style.display = 'none';
      rootEl.setAttribute('data-iconic-also-bought-force-hidden', 'true');
    });
  }

  function setCartPageAlsoBoughtVisible(visible) {
    if (!visible) {
      hideCartPageAlsoBought();
      return;
    }
    clearCartPageAlsoBoughtForceHidden();
    getAllCartPageAlsoBoughtWrappers().forEach(function (wrapper) {
      wrapper.style.display = '';
    });
    document.querySelectorAll('iconic-also-bought').forEach(function (rootEl) {
      if (!isCartPage() || isInCartDrawer(rootEl)) return;
      rootEl.style.display = '';
    });
  }

  function isCartEmptyNow() {
    var cartItems = document.querySelector('cart-items');
    if (cartItems && cartItems.classList.contains('is-empty')) return true;
    return false;
  }

  function syncCartPageAlsoBoughtFromDom() {
    if (!isCartPage()) return;
    if (__iconicAlsoBoughtBusy) return;
    if (__iconicAlsoBoughtIgnoreEmptyUntil && Date.now() < __iconicAlsoBoughtIgnoreEmptyUntil) return;
    if (isCartEmptyNow()) {
      handleCartChange({ item_count: 0 });
      return;
    }
    fetch(CART_URL.replace(/\/?$/, '') + '.js', { headers: { Accept: 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        handleCartChange(cart);
      })
      .catch(function () { /* ignore */ });
  }

  function watchCartEmptyState() {
    if (!isCartPage()) return;
    var cartItems = document.querySelector('cart-items');
    if (!cartItems) return;
    var observer = new MutationObserver(function () {
      if (__iconicAlsoBoughtBusy) return;
      if (__iconicAlsoBoughtIgnoreEmptyUntil && Date.now() < __iconicAlsoBoughtIgnoreEmptyUntil) return;
      syncCartPageAlsoBoughtFromDom();
    });
    observer.observe(cartItems, { attributes: true, attributeFilter: ['class'] });
    syncCartPageAlsoBoughtFromDom();
  }

  function refreshCartPageAlsoBoughtSection() {
    if (!isCartPage()) return;
    var wrapper = getCartPageAlsoBoughtSectionWrapper();
    if (!wrapper) return;

    var sectionKey =
      wrapper.id && wrapper.id.indexOf('shopify-section-') === 0
        ? wrapper.id.replace('shopify-section-', '')
        : 'iconic-also-bought';

    var cartUrl = (window.routes && window.routes.cart_url) || '/cart';
    var url = cartUrl.split('?')[0] + '?section_id=' + encodeURIComponent(sectionKey);

    fetch(url)
      .then(function (res) {
        return res.text();
      })
      .then(function (text) {
        var html = document.createElement('div');
        html.innerHTML = text;
        var next =
          html.querySelector('#' + wrapper.id) ||
          html.querySelector('.shopify-section');
        if (!next) return;
        wrapper.innerHTML = next.innerHTML;
        setCartPageAlsoBoughtVisible(true);
        loadRecommendationBlocks(wrapper);
        updateProRootVisibility(wrapper);
        wrapper.querySelectorAll('[data-iconic-also-bought]:not([data-iconic-also-bought-bound])').forEach(bindProShell);
        wrapper.querySelectorAll('iconic-also-bought').forEach(applyLayoutContext);

        __iconicAlsoBoughtBusy = false;
        document.querySelectorAll('iconic-also-bought').forEach(function (rootEl) {
          rootEl.removeAttribute('data-iconic-also-bought-busy');
        });
      })
      .catch(function (err) {
        console.error('Iconic also bought cart page refresh failed', err);
        __iconicAlsoBoughtBusy = false;
        document.querySelectorAll('iconic-also-bought').forEach(function (rootEl) {
          rootEl.removeAttribute('data-iconic-also-bought-busy');
        });
      });
  }

  function handleCartChange(cartData) {
    if (__iconicAlsoBoughtBusy) return;
    var count =
      cartData && typeof cartData.item_count === 'number' ? cartData.item_count : null;
    if (__iconicAlsoBoughtIgnoreEmptyUntil && Date.now() < __iconicAlsoBoughtIgnoreEmptyUntil) {
      if (count === 0) return;
    }
    if (count === null) return;

    var host = document.querySelector('[data-iconic-also-bought-drawer-host]');
    if (host) {
      if (count === 0) {
        host.innerHTML = '';
        host.style.display = 'none';
        host.dataset.iconicAlsoBoughtDrawerLoaded = 'false';
      } else {
        host.style.display = '';
        host.dataset.iconicAlsoBoughtDrawerLoaded = 'false';
        mountCartDrawerAlsoBought();
      }
    }

    if (!isCartPage()) return;

    if (count === 0) {
      setCartPageAlsoBoughtVisible(false);
      return;
    }

    var wrapper = getCartPageAlsoBoughtSectionWrapper();
    var wasHidden = wrapper && wrapper.style.display === 'none';
    if (wasHidden) {
      refreshCartPageAlsoBoughtSection();
    } else {
      setCartPageAlsoBoughtVisible(true);
      updateProRootVisibility();
    }
  }

  function updateProRootVisibility(scope) {
    var roots;
    if (scope && scope.matches && scope.matches('iconic-also-bought')) {
      roots = [scope];
    } else if (scope && scope.closest) {
      var r = scope.closest('iconic-also-bought');
      roots = r ? [r] : [];
    } else {
      roots = document.querySelectorAll('iconic-also-bought');
    }
    Array.prototype.forEach.call(roots, function (rootEl) {
      if (
        isCartPage() &&
        !isInCartDrawer(rootEl) &&
        (rootEl.getAttribute('data-iconic-also-bought-force-hidden') === 'true' || isCartEmptyNow())
      ) {
        rootEl.style.display = 'none';
        var forcedWrapper = rootEl.closest('.shopify-section');
        if (forcedWrapper) forcedWrapper.style.display = 'none';
        return;
      }
      var has = sectionHasVisibleContent(rootEl);
      rootEl.style.display = has ? '' : 'none';
      if (isCartPage() && !isInCartDrawer(rootEl)) {
        var wrapper = rootEl.closest('.shopify-section');
        if (wrapper) wrapper.style.display = has ? '' : 'none';
      }
      if (has) refreshScrollbarsInRoot(rootEl);
    });
  }

  function loadRecommendationBlocks(scope) {
    var roots;
    if (scope && scope.matches && scope.matches('iconic-also-bought')) {
      roots = [scope];
    } else if (scope && scope.closest) {
      var r = scope.closest('iconic-also-bought');
      roots = r ? [r] : [];
    } else {
      roots = document.querySelectorAll('iconic-also-bought');
    }

    Array.prototype.forEach.call(roots, function (rootEl) {
      rootEl
        .querySelectorAll('product-recommendations.iconic-also-bought-recommendations[data-iconic-also-bought-url]')
        .forEach(function (el) {
          if (el.dataset.iconicAlsoBoughtLoading === 'true' || el.dataset.iconicAlsoBoughtLoaded === 'true') return;
          if (el.querySelector('[data-iconic-also-bought], .iconic-also-bought-empty')) {
            el.dataset.iconicAlsoBoughtLoaded = 'true';
            return;
          }
          el.dataset.iconicAlsoBoughtLoading = 'true';
          var url = el.dataset.iconicAlsoBoughtUrl;
          if (!url) return;
          fetch(url)
            .then(function (res) {
              return res.text();
            })
            .then(function (text) {
              var html = document.createElement('div');
              html.innerHTML = text;
              var nextContent =
                html.querySelector('product-recommendations.iconic-also-bought-recommendations') ||
                html.querySelector('product-recommendations');
              if (nextContent) {
                el.innerHTML = nextContent.innerHTML;
              }
              el.dataset.iconicAlsoBoughtLoaded = 'true';
              el.dataset.iconicAlsoBoughtLoading = 'false';
              updateProRootVisibility(el);
              document.querySelectorAll('[data-iconic-also-bought]:not([data-iconic-also-bought-bound])').forEach(bindProShell);
              initCarousel(el);
            })
            .catch(function (err) {
              console.error('FBT Pro recommendations failed', err);
              el.dataset.iconicAlsoBoughtLoading = 'false';
              updateProRootVisibility(el);
            });
        });
    });
  }

  function init() {
    mountCartDrawerAlsoBought();
    watchCartEmptyState();
    loadRecommendationBlocks();
    document.querySelectorAll('iconic-also-bought').forEach(applyLayoutContext);
    document.querySelectorAll('[data-iconic-also-bought]').forEach(bindProShell);
    updateProRootVisibility();
    setTimeout(function () {
      refreshScrollbarsInRoot(document);
    }, 1200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function () {
    init();
    setTimeout(init, 150);
  });

  document.addEventListener('cart:updated', function (event) {
    handleCartChange(event && event.detail ? event.detail : null);
  });

  document.addEventListener('iconic-also-bought:cart-changed', function (event) {
    handleCartChange(event && event.detail ? event.detail : null);
    setTimeout(function () {
      document
        .querySelectorAll('[data-iconic-also-bought]:not([data-iconic-also-bought-bound])')
        .forEach(bindProShell);
      updateProRootVisibility();
    }, 0);
  });

  if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
    subscribe(window.PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (!event || !event.cartData) return;
      if (event.source === 'iconic-also-bought') return;
      handleCartChange(event.cartData);
    });
  }

  var cartDrawerEl = document.querySelector('cart-drawer');
  if (cartDrawerEl) {
    cartDrawerEl.addEventListener('click', function () {
      setTimeout(mountCartDrawerAlsoBought, 0);
    });
  }

  var observer = new MutationObserver(function (mutations) {
    var added = false;
    mutations.forEach(function (m) {
      if (m.addedNodes.length) added = true;
    });
    if (!added) return;
    loadRecommendationBlocks();
    updateProRootVisibility();
    document.querySelectorAll('[data-iconic-also-bought]:not([data-iconic-also-bought-bound])').forEach(bindProShell);
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();